import {
  finishSeatSelection,
  deletePassenger,
  setPassengers,
  receiveTickets,
  clearSeats,
} from '@/actions/purchase';
import { seatChangeTracker } from '../../../metrics/user-analytics/purchase';
import wayAllowsSeatSelection from '../../../utils/purchase/wayAllowsSeatSelection';

// eslint-disable-next-line import/prefer-default-export
export const dispatchFinishSeatSelection = (history) => {
  return (dispatch, getState) => {
    const { purchase, userPreferences, whitelabelConfig } = getState();
    const plainState = purchase.toJS();
    const { features } = whitelabelConfig;
    const { SHOW_FREQUENT_PASSENGERS } = features;

    const { token, roundTrip } = plainState;
    const isDepartureRoute = history.location.pathname.includes('seats/departure');
    const allowsSeatSelection = wayAllowsSeatSelection(plainState, 'departs');

    let route = `/purchase/${token}/`;
    route += isDepartureRoute && roundTrip ? 'seats/return' : 'passengers';

    seatChangeTracker(plainState, isDepartureRoute ? 'departure' : 'return');
    dispatch(finishSeatSelection());

    const frequentPassengers = userPreferences?.toJS()?.frequentPassengers?.passengers || [];
    const hasFrequentPassengers = SHOW_FREQUENT_PASSENGERS && Boolean(frequentPassengers.length);
    if (hasFrequentPassengers) {
      route += `?frequentPassengers=${hasFrequentPassengers}`;
    }

    if (allowsSeatSelection) history.push(route);
    else history.replace(route);
  };
};

export const dispatchResetPassengers = () => {
  return (dispatch, getState) => {
    const { purchase } = getState();
    const plainState = purchase.toJS();
    const { token, passengers } = plainState;

    passengers.forEach(({ id }) => {
      if (id) dispatch(deletePassenger(token, id));
    });
    dispatch(setPassengers([]));
    dispatch(receiveTickets('departs', []));
    dispatch(receiveTickets('returns', []));
  };
};

/**
 * Clears the previously selected seats for both legs (departure and return).
 * Used when re-entering the seat selection view to edit seats, so the seat the
 * user had chosen is shown unselected instead of pre-loaded (PRO3-72).
 */
export const dispatchClearSelectedSeats = () => (dispatch) => {
  dispatch(clearSeats('departs'));
  dispatch(clearSeats('returns'));
};
